import { useState } from "react";

type InputProps = {
  label?: string;
  value: string;
  editable: boolean;
  className?: string;
};

const InputField = ({ label, value, editable, className = "" }: InputProps) => (
  <div className={` flex justify-between items-center space-y-4 ${className}`}>
    {label && (
      <label className="w-full text-base  text-[#212121]">{label}</label>
    )}
    <input
      type="text"
      value={value}
      disabled={!editable}
      className={`px-4 py-2 text-sm w-full rounded-full outline-none ${
        editable
          ? " bg-white border border-[#D8D8D8]"
          : "bg-[#F2F2F2] border-transparent text-gray-700"
      }`}
    />
  </div>
);

export default function Address() {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <div className=" w-[47rem] mx-auto text-[#1E293B] space-y-8 py-4 ">
      <div className="flex justify-between items-center">
        <p className="text-xs font-semibold text-[#212121]/70">ADDRESS</p>
        <button
          onClick={() => setIsEdit(!isEdit)}
          className="bg-[#FBD037] text-[#212121] text-sm font-semibold px-5 py-1.5 rounded-full"
        >
          {isEdit ? "Save" : "Edit"}
        </button>
      </div>
      <div className="divide-y divide-[#212121]/20 space-y-2">
        <InputField
          label="Address Line"
          value="Dimond Residency building"
          editable={false}
        />
        <InputField
          label="Postal / ZIP Code"
          value="Not Applicable"
          editable={isEdit}
        />
        <InputField label="City" value="Riyad" editable={isEdit} />
        <InputField
          label="State / Province "
          value="East/ Central"
          editable={isEdit}
        />
        <InputField label="Country" value="Saudi Arabia" editable={isEdit} />
      </div>
    </div>
  );
}
